<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-header mb-[20px] flex items-center justify-between">
      <div class="trezo-card-title">
        <h5 class="mb-0">Top Property</h5>
      </div>
      <div class="trezo-card-subtitle">
        <div class="trezo-card-dropdown relative">
          <button
            type="button"
            :class="{
              'trezo-card-dropdown-btn inline-block transition-all text-[26px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500': true,
              active: isActive,
            }"
            id="dropdownToggle"
            @click.stop="toggleActive"
          >
            <i class="ri-more-fill"></i>
          </button>
          <ul
            class="trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none"
          >
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Day
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Week
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Month
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              >
                This Year
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="trezo-card-content">
      <div class="flex items-center gap-[12px] mb-[13px] last:mb-0">
        <img
          src="@/assets/images/properties/top1.jpg"
          class="w-[40px] rounded-[5px]"
          alt="top-image"
        />
        <div>
          <a
            href="#"
            class="inline-block font-semibold sm:text-[15px] md:text-md text-black dark:text-white transition-all hover:text-primary-500"
          >
            Industrial
          </a>
          <span class="block"> 36 Clay Street Indianapolis </span>
        </div>
      </div>
      <div class="flex items-center gap-[12px] mb-[13px] last:mb-0">
        <img
          src="@/assets/images/properties/top2.jpg"
          class="w-[40px] rounded-[5px]"
          alt="top-image"
        />
        <div>
          <a
            href="#"
            class="inline-block font-semibold sm:text-[15px] md:text-md text-black dark:text-white transition-all hover:text-primary-500"
          >
            Office
          </a>
          <span class="block"> 07 Maple Street Los Angeles </span>
        </div>
      </div>
      <div class="flex items-center gap-[12px] mb-[13px] last:mb-0">
        <img
          src="@/assets/images/properties/top3.jpg"
          class="w-[40px] rounded-[5px]"
          alt="top-image"
        />
        <div>
          <a
            href="#"
            class="inline-block font-semibold sm:text-[15px] md:text-md text-black dark:text-white transition-all hover:text-primary-500"
          >
            Multi-Family
          </a>
          <span class="block"> 94 Brooke Street Houston </span>
        </div>
      </div>
      <div class="flex items-center gap-[12px] mb-[13px] last:mb-0">
        <img
          src="@/assets/images/properties/top4.jpg"
          class="w-[40px] rounded-[5px]"
          alt="top-image"
        />
        <div>
          <a
            href="#"
            class="inline-block font-semibold sm:text-[15px] md:text-md text-black dark:text-white transition-all hover:text-primary-500"
          >
            Retail
          </a>
          <span class="block"> 84 Pick Street Centennial </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useClickOutside } from "@/utils/useClickOutside";

export default defineComponent({
  name: "TopProperty",
  setup() {
    const { isActive, toggleActive } = useClickOutside("dropdownToggle");

    return {
      isActive,
      toggleActive,
    };
  },
});
</script>
